import React from 'react';
import Container from './container';
import styled from 'styled-components';
import SocialLinks from './social-links';
import { Link } from 'gatsby';

const Footer = () => {
  return (
    <StyledFooter>
      <FooterWrapper>
        <SocialLinks />

        <SocialLinkList>
          <SocialLinkItem>
            <Link to="/disclaimer">Disclaimer</Link>
          </SocialLinkItem>
          <SocialLinkItem>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </SocialLinkItem>
          <SocialLinkItem>
            <Link to="/terms-and-conditions">Terms and conditions</Link>
          </SocialLinkItem>
        </SocialLinkList>
      </FooterWrapper>
    </StyledFooter>
  );
};

export default Footer;

const StyledFooter = styled.footer`
  padding-top: var(--size-300);
  padding-bottom: var(--size-300);
`;

const SocialLinkList = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
`;

const SocialLinkItem = styled.li`
  margin-right: var(--size-400);
  text-transform: uppercase;
  & a {
    color: inherit;
    font-size: var(--size-300);
  }
`;

const FooterWrapper = styled(Container)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`;
